/*! @azure/msal-browser v4.21.1 2025-08-27 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
const contentError = "ContentError";
const userSwitch = "user_switch";

export { contentError, userSwitch };
//# sourceMappingURL=NativeAuthErrorCodes.mjs.map
